import React, { Component } from 'react';
import { connect } from 'react-redux';

import { userVerify, userVerifyLineCheck } from '../redux/actions'

class LoginverifyLine extends Component {

    constructor() {
        super()
        this.state = {
            fb_id: "",
            pic: "",
            userid: ""
        }
    }
    
    componentWillMount() {
        const params = this.getParams()
        if(!params.id) window.location = "/"
        this.checkSocial(params.id)
        this.setState({
            fb_id: params.id,
            pic: `${params.pic}&height=${params.height}&width=${params.width}&ext=${params.ext}&hash=${params.hash}`
        })       
    }

    getParams() {
        const str = this.props.location.search;
        let objURL = {};
        str.replace(
            new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
            ( $0, $1, $2, $3 ) => {
                objURL[ $1 ] = $3;
            }
        );
        return objURL;
    };

    checkSocial(fbId) {
        this.props.userVerifyLineCheck(fbId, "fb_id")
    }

    _onHandleChange(event) {
		this.setState({
	    	[event.target.name]: event.target.value
	    });
    }
    
    _onSubmit() {
        if(this.state.userid) {
            const data = {
                id: this.state.fb_id,
                pic: this.state.pic,
                status: 1
            }
            this.props.userVerify(data, this.state.userid, "fb_id")
        } else {
            alert("Please fill in a form...")
        }
    }

    render() { 
        return ( 
            <div className="page_login">
                <div className="container">
                    <div className="section-logo">
                        <img src={require("../static/images/01_login/logo.png")} alt="apslogo"/>
                    </div>
                    {(this.props.loadingSocial)? "Loading...":
                        <div className="section-social-login">
                            <input type="text" name="userid" onChange={(event) => this._onHandleChange(event)} placeholder="USER ID" />
                            <button onClick={()=>this._onSubmit()}>ยืนยัน</button>
                        </div>
                    }
                    
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => {
	return {
		loadingSocial: user.loadingSocial
	};
}

export default connect(mapStateToProps, { 
    userVerify, userVerifyLineCheck
})(LoginverifyLine)
